/** Mirrors Cloud Functions `normalizeDonorKey` / `getDonorDocId` for uid-backed donors. */
export function normalizeDonorKey(value: string): string {
  return value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

export function getDonorDocIdForUser(userId: string): string {
  return `uid_${normalizeDonorKey(userId)}`;
}
